import { clsx } from "clsx";
import { AlertTriangle, CheckCircle, Info, X, XCircle } from "lucide-react";
import type { MouseEvent, ReactNode } from "react";
import { useTranslations } from "../../i18n";
import { IconButton } from "../Button/IconButton";
import { Text } from "../Text";
import type { IToastColor, IToastProps } from "./types";

const iconMap: Record<IToastColor, ReactNode> = {
  neutral: <Info size="1.5rem" />,
  brand: <Info size="1.5rem" />,
  info: <Info size="1.5rem" />,
  success: <CheckCircle size="1.5rem" />,
  warning: <AlertTriangle size="1.5rem" />,
  danger: <XCircle size="1.5rem" />,
};

export const ToastItem = ({
  color = "info",
  title,
  message,
  onDismiss,
  ref,
}: IToastProps) => {
  const { t } = useTranslations();

  const rootClass: string = clsx("nuco-toast", `nuco-color-${color}`);

  const handleDismiss = (e: MouseEvent) => {
    e.stopPropagation();
    if (onDismiss) {
      onDismiss();
    }
  };

  return (
    <div ref={ref} className={rootClass}>
      <div className="nuco-toast__icon" aria-hidden="true">
        {iconMap[color]}
      </div>
      <div className="nuco-toast__details">
        {title && (
          <Text weight="bold" as="div" className="nuco-toast__details-title">
            {title}
          </Text>
        )}
        {message && (
          <Text as="div" className="nuco-toast__details-message">
            {message}
          </Text>
        )}
      </div>
      <div className="nuco-toast__actions">
        <IconButton
          variant="ghost"
          size="sm"
          color="neutral"
          aria-label={t("ui.toast.closeNotification")}
          onClickCapture={handleDismiss}
          content={<X />}
        />
      </div>
    </div>
  );
};
